const events = {
	UP: 'up',
	DOWN: 'down',
	ENTER: 'enter',
	UPDATE: 'update',
	DELETE: 'delete',
	SAVE: 'save',
	FACET_CHANGE: 'facetchange',
	FACETS_REVEALED: 'facetsrevealed',
	API_ERROR: 'apierror',
	EXTERNAL_LINK_CLICK: 'externalLinkClick',
	SAMPLES_ADDED: 'samplesadded',
	ACTIVATE_CONSUMER_SIGNUP: 'activateconsumersignup',
	INACTIVE_CONSUMER_SIGNUP: 'inactivateconsumersignup',
	QUANTITY_CHANGED: 'quantitychanged',
	QUANTITY_FOCUSED: 'quantityfocused',
	ACTIVATE_FLY_OUT_BASKET: 'activateflyoutbasket',
	API_EXPIRED_SESSION_ERROR: 'apiexpiredsessionerror',
	PLAY: 'play',
	PAUSE: 'pause',
	VIDEO_PLAYING: 'videoplaying',
	OPEN_NAVIGATE_TO_GATED_SUB_SITE_MODAL: 'opennavigatetogatedsubsitemodal',
};

export default events;
